
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { HttpErrorResponse } from '@angular/common/http';

import * as Objects from '@core/objects';
import * as Access from '@app/models/access';
import { FieldSubmissionValueInterface } from '@core/custom-forms/models/submissions/submissions-custom-form-field-data.model';



export interface CustomFormsFieldsAvailable {
    form_id: string;
    fields: Array<Objects.CustomFormFieldSubmission>;
}

/**
 * to store by each form the updated values to send to backend
 */
export interface FieldSubmissionsValue {
    form_id: string;
    field_values: Array<FieldSubmissionValueInterface>;
}

export interface ProjectsCustomFormsState {
    initialized: boolean;
    forms: Array<Objects.CustomFormSubmission>;
    formsFields: Array<CustomFormsFieldsAvailable>;
    fieldValues: Array<FieldSubmissionsValue>;
    loadingForms: boolean;
    errorForms: HttpErrorResponse;
    loadingFields: { [form_id: string]: boolean }; //the keys are form IDs
    errorFields: { [form_id: string]: HttpErrorResponse }; //the keys are form IDs
}

export const initialState: ProjectsCustomFormsState = {
    initialized: false,
    forms: [],
    formsFields: [],
    fieldValues: [],
    loadingForms: false,
    loadingFields: {},
    errorForms: null,
    errorFields: {}
}

const projectCustomFormsSatateSelector = createFeatureSelector('projects_forms');

// Selectors

export const selectForms = createSelector(
    projectCustomFormsSatateSelector,
    (state: ProjectsCustomFormsState) => state.forms
);

export const selectFields = (formId: string) => createSelector(
    projectCustomFormsSatateSelector,
    (state: ProjectsCustomFormsState) => state.formsFields.find((ff: CustomFormsFieldsAvailable) => ff.form_id === formId)?.fields || []
  );

export const selectLoadingForms = createSelector(
    projectCustomFormsSatateSelector, 
    (state: ProjectsCustomFormsState) => state.loadingForms);

// just used for reload forms.
export const selectInitialized = createSelector(
    projectCustomFormsSatateSelector, 
    (state: ProjectsCustomFormsState) => state.initialized);
    

export const selectErrorForms = createSelector(
    projectCustomFormsSatateSelector, 
    (state: ProjectsCustomFormsState) => state.errorForms);

export const selectLoadingFields = (formId: string) => createSelector(
    projectCustomFormsSatateSelector,
    (state: ProjectsCustomFormsState) => state.loadingFields[formId] || false
);

export const selectErrorFields = (formId: string) => createSelector(
    projectCustomFormsSatateSelector,
    (state: ProjectsCustomFormsState) => state.errorFields[formId] || null
);

export const selectAllFormFieldSubmissionValues = createSelector(
    projectCustomFormsSatateSelector,
    (state: ProjectsCustomFormsState) => state.fieldValues
);

export const selectPendingFormFieldSubmissionValues = createSelector(
    projectCustomFormsSatateSelector,
    (state: ProjectsCustomFormsState) => state.fieldValues.length > 0
);


export const selectFormFieldSubmissionValues = (formId: string) => createSelector(
    projectCustomFormsSatateSelector,
    (state: ProjectsCustomFormsState) => state.fieldValues.find(fieldValue => fieldValue.form_id === formId)?.field_values || []
);

// /**
//  * User the selectFieldValues to get the field values from state
//  * @param id id of the field
//  * @returns field value
//  */
// export const selectFieldValueById = (id: string) => createSelector(
//     selectFieldValues,
//     (values: FieldDataInterfaceValue[]) => values.find(value => value.id === id)
// );